import { call, put } from 'redux-saga/effects';

import { setAllFavoriteQuestions } from '../actions/accountSettingsAction';
import {
  addAudioPlaylistsProgress,
  loadFavoriteQuestion,
  loadResetChapter,
  resetChapterMessagge,
  setAnswerResponse,
  setAudioPlaylist,
  setContentByReference,
  setContentByStudyAll,
  setContentByWarfareQuals,
  setCounterFavorite,
  setCounterMyFavorite,
  setCounterMySubmitted,
  setCounters,
  setCounterSubmitted,
  setErrorMessageGetQuestions,
  setFavoriteMessage,
  setFavoriteQuestionsForStudy,
  setIsLoadingPdfLink,
  setIsLoadingPostExamChecklistPdf,
  setIsLoadingQuestions,
  setIsLoadingReferences,
  setIsLoadingSKTData,
  setMoreQuestions,
  setPdfLink,
  setPostExamChecklistPdfLink,
  setQualById,
  setQuestion,
  setQuestionsByChapter,
  setQuestionsByQuals,
  setQuestionsByRate,
  setResetChapter,
  setSktCounters,
  setSubmittedQuestions,
} from '../actions/studyMainActions';
import Services from '../services';

/**
 * Study Main Sagas
 */

export function* contentByRefSaga(action) {
  try {
    yield put(setIsLoadingReferences(true));
    const rate = action.rate;
    const response = yield call(
      Services.StudyService.getContentByReferenceService,
      rate,
    );
    yield put(setCounterFavorite(response.counterFavorite));
    yield put(setCounterMyFavorite(response.counterFavoriteByUser));
    yield put(setCounterSubmitted(response.counterSubmitted));
    yield put(setCounterMySubmitted(response.counterSubmittedByUser));
    yield put(setContentByReference(response.globalCounters)); // Here we update the reducer state. (We must do this after the API call)
    yield put(setIsLoadingReferences(false));
  } catch (exception) {
    yield put(setIsLoadingReferences(false));
  }
}

export function* loadSktBibsCountersSaga(action) {
  try {
    yield put(setIsLoadingSKTData(true));

    const response = yield call(
      Services.StudyService.getSKTData,
      action.rateId,
      action.rank,
      action.dutyState,
    );
    yield put(setSktCounters(response));
    yield put(setIsLoadingSKTData(false));
  } catch (e) {
    yield put(setIsLoadingSKTData(false));
  }
}

export function* pdfByRerefenceSaga(action) {
  try {
    yield put(setIsLoadingPdfLink(true));
    const response = yield call(
      Services.StudyService.getReferencePdfPrivate,
      action.payload,
    );
    yield put(setPdfLink(response));
    yield put(setIsLoadingPdfLink(false));
  } catch (err) {
    yield put(setIsLoadingPdfLink(false));
  }
}

export function* postExamChecklistPdfSaga() {
  try {
    yield put(setIsLoadingPostExamChecklistPdf(true));
    const response = yield call(
      Services.StudyService.getPostExamChecklistPdfService,
    );
    yield put(setPostExamChecklistPdfLink(response));
    yield put(setIsLoadingPostExamChecklistPdf(false));
  } catch (err) {
    yield put(setIsLoadingPostExamChecklistPdf(false));
  }
}

export function* contentByWarfareQualsSaga(action) {
  try {
    const rate = action.rate;
    const response = yield call(
      Services.StudyService.getContentByWarfareQualsService,
      rate,
    );
    yield put(setContentByWarfareQuals(response)); // Here we update the reducer state. (We must do this after the API call)
  } catch (exception) {}
}

export function* QualFromIdSaga(action) {
  try {
    const qual = action.qual;
    const response = yield call(Services.StudyService.qualFromIdService, qual);
    yield put(setQualById(response)); // Here we update the reducer state. (We must do this after the API call)
  } catch (exception) {}
}

export function* getContentByStudyAllSaga(action) {
  try {
    const rate = action.rate;
    const studyProgram = action.studyProgram;
    let response;
    try {
      response = yield call(
        Services.StudyService.getContentByStudyAllService,
        rate,
        studyProgram,
      );
    } catch (error) {}

    yield put(setContentByStudyAll(response)); // Here we update the reducer state. (We must do this after the API call)
  } catch (exception) {}
}

// --- Questions/ Answers flow

export function* getQuestionsByQualsSaga(action) {
  try {
    yield put(setErrorMessageGetQuestions(''));
    yield put(setIsLoadingQuestions(true));
    const qual = action.qual;
    const studyProgram = action.studyProgram;
    const stackedQuestions = action.stackedQuestions;
    let response;

    try {
      response = yield call(
        Services.StudyService.getQuestionsByQualsService,
        qual,
        studyProgram,
        stackedQuestions,
      );
    } catch (error) {}
    yield put(setMoreQuestions(response.moreQuestions));
    const questions = response.questions;
    if (response.counters) {
      yield put(setCounters(response.counters));
    }
    if (action.isSetQuestion) {
      yield put(setQuestion(questions[0], questions));
      // yield put(setQuestionsByQuals(questions.slice(1, questions.length))); //Here we update the reducer state. (We must do this after the API call)
    } else {
      yield put(setQuestionsByQuals(questions)); // Here we update the reducer state. (We must do this after the API call)
    }

    yield put(setIsLoadingQuestions(false));
  } catch (error) {
    yield put(setIsLoadingQuestions(false));
    yield put(
      setErrorMessageGetQuestions(
        'Error getting the questions, please refresh the page and try again',
      ),
    );
  }
}

export function* getQuestionsByChapterSaga(action) {
  try {
    yield put(setErrorMessageGetQuestions(''));
    yield put(setIsLoadingQuestions(true));
    const chapter = action.chapter;
    const studyProgram = action.studyProgram;
    const stackedQuestions = action.stackedQuestions;
    let response;
    try {
      response = yield call(
        Services.StudyService.getQuestionsByChapterService,
        chapter,
        studyProgram,
        stackedQuestions,
      );
    } catch (error) {
      if (!error.response && error.message === 'Network Error') {
      } else {
        throw error;
      }
    }
    const questions = response.questions;
    yield put(setMoreQuestions(response.moreQuestions));
    if (response.counters) {
      yield put(setCounters(response.counters));
    }
    if (action.isSetQuestion) {
      yield put(setQuestion(questions[0], questions));
      // yield put(setQuestionsByChapter(questions.slice(1, questions.length))); //Here we update the reducer state. (We must do this after the API call)
    } else {
      yield put(setQuestionsByChapter(questions)); // Here we update the reducer state. (We must do this after the API call)
    }
    yield put(setIsLoadingQuestions(false));
  } catch (error) {
    yield put(setIsLoadingQuestions(false));
    yield put(
      setErrorMessageGetQuestions(
        'Error getting the questions, please refresh the page and try again',
      ),
    );
  }
}

export function* getQuestionsByRateSaga(action) {
  try {
    yield put(setErrorMessageGetQuestions(''));
    yield put(setIsLoadingQuestions(true));
    const stackedQuestions = action.stackedQuestions;
    let response;
    try {
      response = yield call(
        Services.StudyService.getQuestionsByRateService,
        stackedQuestions,
      );
    } catch (error) {
      if (!error.response && error.message === 'Network Error') {
      } else {
        throw error;
      }
    }

    yield put(setMoreQuestions(response.moreQuestions));
    const questions = response.questions;
    if (response.counters) {
      yield put(setCounters(response.counters));
    }

    if (action.isSetQuestion) {
      yield put(setQuestion(questions[0], questions));
      // yield put(setQuestionsByRate(questions.slice(1, questions.length))); //Here we update the reducer state. (We must do this after the API call)
    } else {
      yield put(setQuestionsByRate(questions)); // Here we update the reducer state. (We must do this after the API call)
    }
    yield put(setIsLoadingQuestions(false));
  } catch (error) {
    yield put(setIsLoadingQuestions(false));
    yield put(
      setErrorMessageGetQuestions(
        'Error getting the questions, please refresh the page and try again',
      ),
    );
  }
}

export function* getQuestionsByPersonalizedStudyAllSaga(action) {
  try {
    yield put(setErrorMessageGetQuestions(''));
    yield put(setIsLoadingQuestions(true));
    const studyProgram = action.studyProgram;
    const stackedQuestions = action.stackedQuestions;
    let response;
    try {
      response = yield call(
        Services.StudyService.getQuestionsByPersonalizedStudyAllService,
        studyProgram,
        stackedQuestions,
      );
    } catch (error) {
      if (!error.response && error.message === 'Network Error') {
      } else {
        throw error;
      }
    }

    yield put(setMoreQuestions(response.moreQuestions));
    const questions = response.questions;
    if (response.counters) {
      yield put(setCounters(response.counters));
    }

    if (action.isSetQuestion) {
      yield put(setQuestion(questions[0], questions));
    } else {
      yield put(setQuestionsByRate(questions));
    }
    yield put(setIsLoadingQuestions(false));
  } catch (error) {
    yield put(setIsLoadingQuestions(false));
    yield put(
      setErrorMessageGetQuestions(
        'Error getting the questions, please refresh the page and try again',
      ),
    );
  }
}

export function* sendAnswerSaga(action) {
  try {
    const answer = action.answer;
    const response = yield call(
      Services.StudyService.sendAnswerService,
      answer,
    );
    if (response.message) {
      yield put(setAnswerResponse(response.message[0]));
    } else {
      yield put(setAnswerResponse('ANSWER_OK'));
    }
  } catch (exception) {}
}

export function* favoriteQuestionSaga(action) {
  try {
    yield put(loadFavoriteQuestion(true));
    let response;
    if (action.addToFavorites) {
      response = yield call(
        Services.StudyService.favoriteQuestionService,
        action.questionId,
        action.userId,
      );
      yield put(setAllFavoriteQuestions(response));
      yield put(setFavoriteMessage('add'));
    } else {
      response = yield call(
        Services.StudyService.removeFavoriteQuestionService,
        action.questionId,
        action.userId,
      );
      yield put(setAllFavoriteQuestions(response));
      yield put(setFavoriteMessage('remove'));
    }
  } catch (exception) {
    yield put(setFavoriteMessage('error'));
  } finally {
    yield put(loadFavoriteQuestion(false));
  }
}

export function* getStudyFavoriteQuestionSaga(action) {
  try {
    yield put(setErrorMessageGetQuestions(''));
    yield put(setIsLoadingQuestions(true));
    const stackedQuestions = action.stackedQuestions;
    const response = yield call(
      Services.StudyService.getStudyFavoriteQuestionService,
      stackedQuestions,
    );

    yield put(setMoreQuestions(response.moreQuestions));
    const questions = response.questions;
    if (response.counters) {
      yield put(setCounters(response.counters));
    }
    if (action.isSetQuestion) {
      yield put(setQuestion(questions[0], questions));
    } else {
      yield put(setFavoriteQuestionsForStudy(questions));
    }
    yield put(setIsLoadingQuestions(false));
  } catch (error) {
    yield put(setIsLoadingQuestions(false));
    yield put(
      setErrorMessageGetQuestions(
        'Error getting the questions, please refresh the page and try again',
      ),
    );
  }
}

export function* getStudyMyFavoriteQuestionSaga(action) {
  try {
    yield put(setErrorMessageGetQuestions(''));
    yield put(setIsLoadingQuestions(true));
    const stackedQuestions = action.stackedQuestions;
    const response = yield call(
      Services.StudyService.getStudyMyFavoriteQuestionService,
      stackedQuestions,
    );

    yield put(setMoreQuestions(response.moreQuestions));
    const questions = response.questions;
    if (response.counters) {
      yield put(setCounters(response.counters));
    }
    if (action.isSetQuestion) {
      yield put(setQuestion(questions[0], questions));
    } else {
      yield put(setFavoriteQuestionsForStudy(questions));
    }
    yield put(setIsLoadingQuestions(false));
  } catch (error) {
    yield put(setIsLoadingQuestions(false));
    yield put(
      setErrorMessageGetQuestions(
        'Error getting the questions, please refresh the page and try again',
      ),
    );
  }
}

export function* getStudySubmittedQuestionSaga(action) {
  try {
    yield put(setErrorMessageGetQuestions(''));
    yield put(setIsLoadingQuestions(true));
    const stackedQuestions = action.stackedQuestions;
    const response = yield call(
      Services.StudyService.getStudySubmittedQuestionService,
      stackedQuestions,
    );

    yield put(setMoreQuestions(response.moreQuestions));
    const questions = response.questions;

    if (response.counters) {
      yield put(setCounters(response.counters));
      yield put(setCounterSubmitted(response.counters));
    }

    if (action.isSetQuestion) {
      yield put(setQuestion(questions[0], questions));
    } else {
      yield put(setSubmittedQuestions(questions)); // Here we update the reducer state. (We must do this after the API call)
    }
  } catch (error) {
    yield put(setIsLoadingQuestions(false));
    yield put(
      setErrorMessageGetQuestions(
        'Error getting the questions, please refresh the page and try again',
      ),
    );
  } finally {
    yield put(setIsLoadingQuestions(false));
  }
}

export function* getStudyMySubmittedQuestionSaga(action) {
  try {
    yield put(setErrorMessageGetQuestions(''));
    yield put(setIsLoadingQuestions(true));
    const stackedQuestions = action.stackedQuestions;
    const response = yield call(
      Services.StudyService.getStudyMySubmittedQuestionService,
      stackedQuestions,
    );

    yield put(setMoreQuestions(response.moreQuestions));
    const questions = response.questions;

    if (response.counters) {
      yield put(setCounters(response.counters));
      yield put(setCounterSubmitted(response.counters));
    }

    if (action.isSetQuestion) {
      yield put(setQuestion(questions[0], questions));
    } else {
      yield put(setSubmittedQuestions(questions)); // Here we update the reducer state. (We must do this after the API call)
    }
  } catch (error) {
    yield put(setIsLoadingQuestions(false));
    yield put(
      setErrorMessageGetQuestions(
        'Error getting the questions, please refresh the page and try again',
      ),
    );
  } finally {
    yield put(setIsLoadingQuestions(false));
  }
}

export function* getUserAnswersSagas(action) {
  try {
    yield call(Services.StudyService.getUserAnswersServices, action.payload);
  } catch (exception) {}
}

export function* updateUserAnswersSagas(action) {
  try {
    yield call(Services.StudyService.updateUserAnswersServices, action.value);
  } catch (exception) {}
}

export function* checkChapterInReviewSagas(action) {
  try {
    yield call(
      Services.StudyService.checkChapterInReviewServices,
      action.value,
    );
  } catch (err) {}
}

export function* updateDisabledChapterSagas(action) {
  try {
    const response = yield call(
      Services.StudyService.chapterStatusServices,
      action.userId,
      action.chapterId,
    );
  } catch (err) {}
}

export function* getAudioPlaylistSagas(action) {
  try {
    const response = yield call(
      Services.StudyService.getAudioPlaylist,
      action.chapterId,
    );
    yield put(setAudioPlaylist(response));
  } catch (err) {}
}

export function* getAudioPlaylistProgressWorkerSaga(action) {
  const progressByChapter = yield call(
    Services.StudyService.getAudioPlaylistsProgress,
    action.payload.chapterIds,
  );
  yield put(addAudioPlaylistsProgress(progressByChapter));
}
export function* updateAudioPlaylistProgressWorkerSaga(action) {
  yield call(
    Services.StudyService.updateAudioPlaylistProgress,
    action.payload.chapterId,
    action.payload.nextQuestionId,
    action.payload.status,
  );
}

export function* resetChapterSaga(action) {
  try {
    const userId = action.value.userId;
    const chapterId = action.value.chapterId || null;
    const method = action.value.method;
    const chapterIds = action.value.chapterIds || null;

    yield put(loadResetChapter(true));

    let response;
    if (method) {
      response = yield call(Services.StudyService.resetChapterService, {
        userId,
        method,
      });
    } else {
      response = yield call(Services.StudyService.resetChapterService, {
        userId,
        chapterId,
        chapterIds,
      });
    }

    yield put(loadResetChapter(false));
    yield put(setResetChapter(response));
  } catch (err) {
    yield put(loadResetChapter(false));
    yield put(
      resetChapterMessagge({
        type: 'error',
        text: 'Unable to reset the chapter. Please try again later or contact the support',
      }),
    );
  }
}

export default function* sagas() {
  yield [
    contentByRefSaga(),
    loadSktBibsCountersSaga(),
    contentByWarfareQualsSaga(),
    getQuestionsByQualsSaga(),
    getQuestionsByRateSaga(),
    getQuestionsByChapterSaga(),
    sendAnswerSaga(),
    QualFromIdSaga(),
    getUserAnswersSagas(),
    updateUserAnswersSagas(),
    updateDisabledChapterSagas(),
    getAudioPlaylistSagas(),
    getAudioPlaylistProgressWorkerSaga(),
    updateAudioPlaylistProgressWorkerSaga(),
  ];
}
